<template>
  <div>
    <div>
      <div class="block">
        <el-cascader
          :options="rowData.questionDetails.issue.groups"
          :props="{
            value: 'id',
            label: 'content',
            children: 'nextLevelOptions'
          }"
          v-model="getLinkage(rowData).model"
          @change="updateCascade($event, rowData)"
        >
          <template slot-scope="{ node, data }">
            <el-tooltip
              :disabled="data.content.length < 14"
              class="tooltip-style"
              effect="light"
              :content="data.content"
              placement="top"
            >
              <span style="max-width: 220px; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{
                data.content
              }}</span>
            </el-tooltip>
          </template>
        </el-cascader>
        <div v-if="rowData.questionDetails.issue.levelsNum < rowData.questionDetails.issue.requiredNum" class="mt-2">
          <el-input :value="rowData.items[3] && rowData.items[3].value" placeholder="详细地址" @change="updateDetailAddress($event, rowData)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { itemInitOptions } from '../config/config.js'
import '../public/style.css'
import { saveArr } from '../public/index.js'

export default {
  name: 'Linkage',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    getLinkage() {
      return function (row) {
        let valArr = []
        if (row.items.length >= 1) {
          row.items.forEach(element => {
            valArr.push(element.optionId)
          })
        }
        if (valArr.length == 4) {
          valArr.splice(3, 1)
        }
        return {
          model: valArr
        }
      }
    }
  },
  methods: {
    getItems(question, value) {
      question.forEach(questionItem => {
        if (value.includes(questionItem.id)) {
          this.rowData.items.push(
            Object.assign({}, itemInitOptions, {
              value: questionItem.content,
              optionId: questionItem.id
            })
          )
          questionItem.nextLevelOptions && this.getItems(questionItem.nextLevelOptions, value)
        }
      })
    },
    updateCascade(value, row) {
      let detailAddress = row.items[3]
      row.items = []
      this.getItems(row.questionDetails.issue.groups, value)
      if (row.questionDetails.issue.levelsNum < row.questionDetails.issue.requiredNum) {
        row.items.push(detailAddress)
      }
      // let existId = this.updateArr.findIndex(item => item.questonId === row.questonId);
      // if(existId === -1){
      //   this.updateArr.push(row);
      // }
      this.saveArr()
    },
    updateDetailAddress(value, row) {
      this.rowData.items[3] && (this.rowData.items[3].value = value)
      this.saveArr()
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped></style>
